import { createSlice } from '@reduxjs/toolkit'

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: {
    authenticated: false,
    principal: null,
  },
  reducers: {
    set_principal:  (state, action) => {
      const principal = action.payload;
      state.principal = action.payload;
      state.authenticated = !!principal?.id;
    },
  }
})

// Action creators are generated for each case reducer function
export const { set_principal } = authenticationSlice.actions

export default authenticationSlice.reducer